module.exports = __webpack_public_path__ + "au.no2.3b847173.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/au.no2.jpg
// module id = NCZE
// module chunks = 0